import React from 'react';
import {BrowserRouter,Routes,Route} from 'react-router-dom';
import Home from './Pages/Home';
import Header from './Pages/Header';
import Footer from './Pages/Footer';
import Cities from './Pages/Cities';
import PreLoader from './Pages/PreLoader';



function App() {


  return (
<>

<PreLoader/>

<BrowserRouter>
<Routes>
   <Route path='/' element={<Header />}>
   <Route index element={<Home />} />
   <Route path='cities' element={<Cities/>}/>
   </Route>
</Routes>
</BrowserRouter>

<Footer/>

</>
  );
}

export default App;
